/**
 * Centralized API Service
 *
 * - Attaches JWT token to requests (from auth utility)
 * - On expired/invalid token: clears auth and redirects to login
 * - Handles 401 (redirect to login) and 403 (redirect to /403)
 */

import axios from "axios";
import { clearAuthAndRedirectToLogin } from "../utils/auth";
import { getApiBaseUrl } from "../config/apiBase";
import { prepareRequestConfig } from "./requestAuth";

const API_BASE = getApiBaseUrl();

const api = axios.create({
  baseURL: API_BASE,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use(
  (config) => prepareRequestConfig(config),
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      clearAuthAndRedirectToLogin();
    } else if (error.response?.status === 403 && window.location.pathname !== "/403") {
      window.location.href = "/403";
    }
    return Promise.reject(error);
  }
);

export default api;
